import {inputTypeEnum} from "../../serverClientShared/sharedEnums";
import TextField from "@mui/material/TextField";
import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import PropTypes from "prop-types";


const NodeInput = observer(props => {
    const {procedureStore, generalStore} = useStores();
    
    const [inputValue, setInputValue] = useState('');
    const {isPreview} = props;
    // eslint-disable-next-line
    const currentNode = (isPreview
            ? procedureStore.currentPreviewedNode
            : procedureStore.currentNode
    ) || {};

    const isInputMobileOnly = [inputTypeEnum.BARCODE, inputTypeEnum.IMAGE].includes(currentNode?.InputParams?.Type);

    const isValid = validateInputText();
    let placeholder;
    switch (currentNode?.InputParams?.Type) {
        case inputTypeEnum.NUMBER:
            placeholder = generalStore.translate('insertNumber_withEllipsis');
            break;
        case inputTypeEnum.TEXT:
            placeholder = generalStore.translate('insertText_withEllipsis');
            break;
        default:
            placeholder = '';
    }


    useEffect(() => {
        if (!currentNode || !currentNode.InputParams) {
            return;
        }

        let newInputValue = currentNode.InputParams.Value || currentNode.InputParams.DefaultValue;
        newInputValue = procedureStore.sessionViewerOpen ?
            currentNode.sessionInput :
            !isInputMobileOnly ?
                newInputValue :
                generalStore.translate('fillWhenInHandheldSession');

        setInputValue(newInputValue);

        // eslint-disable-next-line
    }, [currentNode, isInputMobileOnly, procedureStore.sessionViewerOpen]);


    function validateInputText() {
        if (isInputMobileOnly) {
            return true;
        }
        if (currentNode?.InputParams?.Type === inputTypeEnum.NUMBER) {
            return !isNaN(parseInt(inputValue)) || !inputValue;
        }
        return true;
    }

    function saveInSession() {
        if (isPreview) {
            procedureStore.currentPreviewedNode.InputParams.Value = inputValue;
            return;
        }

        procedureStore.editNodeSessionInput(currentNode.InputParams, inputValue)
    }


    return (
        <div className='step-input-container'>

            <TextField
                onDoubleClick={e => e.stopPropagation()}
                className='step-input'
                variant="outlined"
                disabled={isInputMobileOnly || procedureStore.sessionViewerOpen}
                error={!isValid}
                helperText={isValid ? '' : generalStore.translate('illegalValue')}
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                onBlur={saveInSession}
                placeholder={placeholder}
            />
        </div>

    );
});

NodeInput.propTypes = {
    isPreview: PropTypes.bool.isRequired
}

export default NodeInput;
